// import components
import Checkout from '@/components/checkout/Checkout'
import Terms from '@/components/checkout/Terms'
import Payment from '@/components/checkout/Payment'
export default [
  {
    path: 'main',
    component: Checkout
  },
  {
    path: 'terms',
    component: Terms
  },
  {
    path: 'payment',
    component: Payment
  }
]
